import { AlertPagination } from '../../domain/model/alert_pagination';
import { Pagination } from '@/core/domain/model/pagination';
import { AxiosResponse, AxiosInstance, AxiosError } from 'axios';
import Handler from '@/core/domain/usecase/handler';

export interface FetchAlertRepository {
    (pagination: Pagination): Promise<AlertPagination>
}

const fetchAlertRepository = (axios: AxiosInstance): FetchAlertRepository => async (pagination: Pagination) => {
    try {
        const response: AxiosResponse = await axios.get('/alert', {
            params: pagination,
        })

        const alertPagination: AlertPagination = response.data
        return alertPagination
    } catch (err: any | AxiosError) {
        if (err.isAxiosError) {
            throw new Handler().trataErro(err)
        } else {
            throw err
        }
    }
}

export default fetchAlertRepository